import { Box, CircularProgress, SxProps } from "@mui/material";

import { Delayed } from "./Delayed";

export function LoadingIndicator(props: { sx?: SxProps }) {
  const { sx } = props;
  return (
    <Delayed ms={100}>
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          top: 0,
          right: 0,
          height: "100%",
          width: "100%",
          backgroundColor: "background.paper",
          zIndex: 50,
          opacity: "50%",
          ...sx,
        }}
      >
        <CircularProgress />
      </Box>
    </Delayed>
  );
}
